import CookiesJS from 'cookies-js';

export function initUserParams($, apiClient) {
    function getStatValue(key) {
        const val = $(`#${key}`).val();
        if (val === '') return undefined;
        return parseFloat(val);
    }

    function getStats(keys) {
        const stats = {};
        for (const key of keys) {
            stats[key] = getStatValue(key);
        }
        return stats;
    }

    $('form.user-params-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const userParams = {
                title: $('#title').val(),
                type: parseInt($('#type').val()),
                ageFrom: parseFloat($('#ageFrom').val()),
                ageTo: parseFloat($('#ageTo').val()),
                ...getStats([
                    'proteins',
                    'fat',
                    'carbohydrate',
                    'deficit',
                    'surplus',
                    'cellulose',
                    'vitaminA',
                    'betaCarotene',
                    'alphaCarotene',
                    'folic',
                    'clorine',
                    'iodine',
                    'vitaminD',
                    'vitaminD2',
                    'vitaminD3',
                    'vitaminE',
                    'vitaminK',
                    'vitaminC',
                    'vitaminB1',
                    'vitaminB2',
                    'vitaminB3',
                    'vitaminB4',
                    'vitaminB5',
                    'vitaminB6',
                    'vitaminB7',
                    'vitaminB9',
                    'vitaminB12',
                    'calcium',
                    'iron',
                    'magnesium',
                    'phosphorus',
                    'potassium',
                    'sodium',
                    'zinc',
                    'copper',
                    'manganese',
                    'selenium',
                    'fluorine',
                    'water',
                    'ash',
                    'sugar',
                    'fiber',
                    'starch',
                    'cholesterol',
                    'transfats'
                ]),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/user-params', userParams, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/user-params/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/user-params', _id, userParams, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
